import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./BeforeAfter.module.css";

/* Material Symbols close/check 24dp — mesmos vetores usados no Figma */
function IconClose() {
  return (
    <svg aria-hidden="true" className={styles.icon} viewBox="0 -960 960 960">
      <path d="M256-200l-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </svg>
  );
}

function IconCheck() {
  return (
    <svg aria-hidden="true" className={styles.icon} viewBox="0 -960 960 960">
      <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>
  );
}

export function BeforeAfter() {
  const { beforeAfter, brand } = useMaestriaContent();
  const [afterHead, afterAccent] = beforeAfter.afterTitle.split(/(?=Imersão|Immersion)/);

  return (
    <section
      id="antes-depois"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="before-after-title"
    >
      <h2 id="before-after-title" className={styles.srOnly}>
        {beforeAfter.srTitle ?? "Antes e depois da Imersão"}
      </h2>

      <div className={styles.before}>
        <div className={styles.panel}>
          <h3 className={`${styles.title} ${styles.titleBefore}`}>{beforeAfter.beforeTitle}</h3>
          <ul className={styles.list}>
            {beforeAfter.before.map((item) => (
              <li key={item} className={`${styles.pill} ${styles.pillBefore}`}>
                <IconClose />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className={styles.after}>
        <div className={styles.panel}>
          <h3 className={`${styles.title} ${styles.titleAfter}`}>
            {afterHead}
            <span className={styles.titleAccent}>{afterAccent}</span>
          </h3>
          <ul className={styles.list}>
            {beforeAfter.after.map((item) => (
              <li key={item} className={`${styles.pill} ${styles.pillAfter}`}>
                {item}
                <IconCheck />
              </li>
            ))}
          </ul>
        </div>

        <img
          className={styles.deco1}
          src={beforeAfter.decor[0]}
          alt=""
          aria-hidden="true"
          width={172}
          height={172}
          loading="lazy"
        />
        <img
          className={styles.deco2}
          src={beforeAfter.decor[1]}
          alt=""
          aria-hidden="true"
          width={263}
          height={263}
          loading="lazy"
        />
      </div>

      {/* pilula dourada com o wordmark, centrada sobre a divisa das colunas */}
      <div className={styles.badge} aria-hidden="true">
        <span className={styles.badgeMark}>{brand.name}</span>
      </div>
    </section>
  );
}
